"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Checkbox extends React.Component {
    render() {
        const { className, style, checked, indeterminate, onChange, disabled } = this.props;
        return (React.createElement("input", { type: "checkbox", className: className, style: style, ref: input => {
                /* istanbul ignore else */
                if (input) {
                    input.checked = checked;
                    input.indeterminate = indeterminate;
                    input.disabled = disabled;
                }
            }, onChange: onChange }));
    }
}
/* istanbul ignore next: callback */
Checkbox.defaultProps = {
    indeterminate: false,
    className: '',
    style: {},
    disabled: false,
    onChange: () => { } // tslint:disable-line no-empty
};
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map